export function formatUnknownError(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  if (err && typeof err === "object") {
    const rec = err as Record<string, unknown>;
    const msg =
      (typeof rec.message === "string" && rec.message) ||
      (typeof rec.error === "string" && rec.error) ||
      (typeof rec.details === "string" && rec.details) ||
      (typeof rec.hint === "string" && rec.hint) ||
      "";
    if (msg) return msg;
    try {
      return JSON.stringify(rec);
    } catch {
      return "Unknown contact-directory error";
    }
  }
  return "Unknown contact-directory error";
}

/** Normalize DB/jsonb topics (array or comma string) for form fields and tag chips. */
export function directoryTopicsToCommaString(topics: unknown): string {
  if (topics == null) return "";
  if (Array.isArray(topics)) {
    return topics.map((t) => String(t ?? "").trim()).filter(Boolean).join(", ");
  }
  return String(topics).trim();
}

export function parseTopicsText(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((t) => String(t ?? "").trim()).filter(Boolean);
  }
  if (value == null) return [];
  return String(value)
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
}

export function normalizeEmail(value: string | null | undefined): string {
  return String(value ?? "").trim().toLowerCase();
}

export function isLikelyValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function hasAtLeastTwoWords(value: string): boolean {
  return (
    value
      .trim()
      .split(/\s+/)
      .filter(Boolean).length >= 2
  );
}

export function normalizePhone(value: string | null | undefined): string {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return digits.slice(1);
  return digits;
}

export function formatUsPhone(value: string | null | undefined): string {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    const local = digits.slice(1);
    return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
  return value?.trim() || "—";
}
